import { Component, input } from '@angular/core';

@Component({
    selector: 'r1-compass-lib-loading-spinner',
    template: `
        <div class="r1-loading-spinner-overlay">
            <div class="r1-loading-spinner"></div>
            @if (loadingMessages().length) {
                <div class="r1-loading-message-container">
                    <span class="r1-loading-message">{{ loadingMessages()[0] }}</span>
                </div>
            }
        </div>
    `,
    styleUrl: './loading-spinner.component.scss',
})
export class LoadingSpinnerComponent {
    readonly loadingMessages = input<string[]>([]);
}
